import { useState, useEffect } from 'react';
import { useTenant } from '../../../../hooks/useTenant';
import { CatalogService } from '../../../../services/Admin/CatalogService';
import { toast } from 'react-toastify';

/**
 * Hook para carregar itens do Catálogo (Produtos e Serviços) para uso no PDV.
 * Substitui completamente os dados mockados de salesMockData.js.
 */
export const useCatalogItems = () => {
    const { idTenant, loading: tenantLoading } = useTenant();
    const isReady = !tenantLoading && !!idTenant;
    const [products, setProducts] = useState([]);
    const [services, setServices] = useState([]);
    const [loadingCatalog, setLoadingCatalog] = useState(false);

    useEffect(() => {
        if (!isReady) return;

        const loadItems = async () => {
            setLoadingCatalog(true);
            try {
                const [prods, servs] = await Promise.all([
                    CatalogService.listWithFilters(idTenant, null, { type: 'product', isActive: true }),
                    CatalogService.listWithFilters(idTenant, null, { type: 'service', isActive: true }),
                ]);
                setProducts(prods);
                setServices(servs);
            } catch (error) {
                console.error('[useCatalogItems] Erro ao carregar catálogo:', error);
                toast.error('Erro ao carregar produtos e serviços.');
            } finally {
                setLoadingCatalog(false);
            }
        };

        loadItems();
    }, [idTenant, isReady]);

    return { products, services, loadingCatalog };
};
